/**
 * 답례품 할인율(%) — 고객에게 보이는 모든 곳(목록 카드·상품 상세·미리보기 모달·전화응대 카탈로그) 공용.
 * 소수점은 **올림**한다 (1.x% → 2%).
 *
 * `(차액 / 정가) * 100`으로 계산하면 부동소수 오차로 정확히 10%가 10.000000000000002가 되어
 * 올림 시 11%로 튄다. 정수끼리 먼저 곱한 뒤 나눠(`차액 * 100 / 정가`) 나누어떨어지는 값은 정확히 떨어지게 한다.
 */
export const giftDiscountRate = (priceRegular: number, priceRetail: number): number => {
  if (!(priceRegular > 0) || !(priceRetail < priceRegular)) return 0;
  return Math.ceil(((priceRegular - priceRetail) * 100) / priceRegular);
};
